export const fillVariables = (template, variables) => {
  // template should be a url:
  // - url got from backend by route name
  // - url got from "php artisan route:list" (with usage of {variables}) e.g. venue-cabinet/venue/{id}/location
  if (!template) {
    throw new Error(`Couldn't fill route variable for template: ${template}`);
  }

  if (!variables || typeof variables !== 'object') {
    throw new Error('Variables must be an object');
  }

  let filled = template;
  Object.keys(variables).forEach((key) => {
    const dashedPlaceholder = `-${key}-`;
    const bracedPlaceholder = `{${key}}`;
    if (!filled.includes(dashedPlaceholder) && !filled.includes(bracedPlaceholder)) {
      // Extra/optional variables not used by this template are ignored (may be nullish).
      return;
    }

    const value = variables[key];
    if (value === undefined || value === null) {
      // Array.join(undefined) falls back to the default "," separator, so an undefined
      // value would otherwise be silently baked into the URL as a phantom comma.

      // ugly, but to be sure we don't catch this exception somewhere that could be potentially breaking
      // can be removed in the future if nothing reported
      Rollbar.error(`Missing value for route variable "${key}" in template: ${template}`);
      throw new Error(`Missing value for route variable "${key}" in template: ${template}`);
    }
    filled = filled.split(dashedPlaceholder).join(String(value));
    filled = filled.split(bracedPlaceholder).join(String(value));
  });

  return filled;
};
